// extracted by mini-css-extract-plugin
module.exports = {"action-button":"customize-button__action-button___1sQPG"};